<p-toggleswitch
  class="pm-form-field-switch"
  [name]="formField.value"
  [(ngModel)]="formField.value"
  [inputId]="formField.value"
  [formControl]="ctrl"
/>
